import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

/** @deprecated Exporting the component so that it can be used in other files. */
export default RadioButtonCheckedIcon;
